<script lang="ts">
    import type { Snippet } from 'svelte';

    interface Props {
        children?: Snippet;
    }

    let { children }: Props = $props();
</script>

<div class="reptile-price__priceAndUVP">
    {@render children?.()}
</div>

<style lang="scss">
    .reptile-price {
        &__priceAndUVP {
            display: flex;
            flex-flow: row wrap-reverse;
            align-items: baseline;
        }
    }
</style>
